import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import Inputmask from 'inputmask'
import states from './states.json'
import Autocomplete from "react-google-autocomplete";
import $ from 'jquery';
import PhoneField from '../PhoneField'
import toastr from 'toastr'

function Step5({ validateField }) {
    setTimeout(() => {
        const arr = document.querySelectorAll('[data-inputmask]');
        Inputmask({ 'placeholder': '' }).mask(arr);
    }, 500);
    const authContext = useContext(AuthContext);
    let { lead, gotoNextStep, step } = authContext;
    let owner = lead.owners[0];
    const initialState = {
        first_name: owner.first_name,
        last_name: owner.last_name,
        business_phone: lead.business_phone,
        business_phone_extension: owner.business_phone_extension ? owner.business_phone_extension : '+1',

        business_email: lead.business_email ? lead.business_email : owner.email,
        website: lead.website ? lead.website : '',
        business_dba: lead.business_dba ? lead.business_dba : '',
        business_legal_name: lead.business_legal_name ? lead.business_legal_name : '',
        business_ownership: lead.business_ownership ? lead.business_ownership : '',
        business_address: lead.business_address ? lead.business_address : '',
        business_city: lead.business_city ? lead.business_city : '',
        business_state: lead.business_state ? lead.business_state : '',
        business_zip: lead.business_zip ? lead.business_zip : '',
        business_suite: lead.business_suite ? lead.business_suite : '',
        short_address: lead.short_address ? lead.short_address : '',
        has_suite: lead.business_suite ? true : false
    }
    const [fields, setFields] = useState(initialState);
    const handlePrepopulate = (result, e) => {

        let $hasZip, $hasCity, $hasState, $short_address = '';
        if (result.address_components) {
            result.address_components.forEach(element => {
                // console.log(element);
                if (element.types.includes("postal_code")) {
                    $hasZip = 1;
                    var $el = document.getElementsByName('business_zip')[0];
                    $el.value = element.long_name;
                    handleChange($el, 'custom');
                }
                if (element.types.includes("locality") || element.types.includes("political") && $hasCity !== 1) {
                    $hasCity = 1;
                    var $el = document.getElementsByName('business_city')[0]
                    $el.value = element.long_name;
                    handleChange($el, 'custom');
                }
                if ((element.types.includes("sublocality_level_1") || element.types.includes("sublocality")) && $hasCity !== 1) {
                    var $el = document.getElementsByName('business_city')[0];
                    $el.value = element.long_name;
                    $hasCity = 1;
                    handleChange($el, 'custom');

                }
                if (element.types.includes("administrative_area_level_1")) {
                    var $el = document.getElementsByName('business_state')[0];
                    $el.value = element.short_name;
                    $hasState = 1;
                    handleChange($el, 'custom');
                }
                if (element.types.includes("street_number")) {
                    $short_address += element.long_name + ' ';
                }
                if (element.types.includes("route")) {
                    $short_address += element.long_name;
                }
            });
            if ($hasZip === 1) {
                $('#zipCol').addClass('d-none');
            } else {
                $('#zipCol').removeClass('d-none');
            }
            if ($hasCity === 1) {
                $('#cityCol').addClass('d-none');
            } else {
                $('#cityCol').removeClass('d-none');
            }
            if ($hasState === 1) {
                $('#stateCol').addClass('d-none');
            } else {
                $('#stateCol').removeClass('d-none');
            }
            e.value = result.formatted_address.replace(', USA', '');
            handleChange(e, 'custom');
            setFields(fields => {
                return { ...fields, short_address: $short_address }
            });

        }
    }
    const handleChange = (event, isCustom) => {
        let target;
        // console.log(event, isCustom); 
        if (!isCustom) {
            target = event.target;
        } else {
            target = event;
        }
        let value = target.value;
        let index = target.name;
        // console.log(index, value)
        validateField(target);
        setFields(fields => {
            return { ...fields, [index]: value }
        });

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const $array = Object.keys(fields);
        const $errorbag = [];
        $array.map((item) => {
            const target = document.getElementsByName(item)[0];
            if (target) {
                let $result = validateField(target);
                if ($result) {
                    $errorbag.push($result);
                }
            }
            return null;
        });
        if ($errorbag.length === 0) {
            gotoNextStep(fields, step);
        } else {
            let $format = '';
            $errorbag.map((error, i) => {
                const $err = error + '<br/>';
                $format += $err;
                return null;
            })
            toastr.error($format);
        }
    }
    const handleShowSuite = () => {
        setFields(fields => {
            if (fields.has_suite == true) {
                return { ...fields, has_suite: !fields.has_suite, business_suite: null }
            }
            return { ...fields, has_suite: !fields.has_suite }
        });
    }
    const gmaps = 'AIzaSyCpc5j5FV6ESKlrunh4QHmHAVmN1z6QZ8E';
    return (
        <>

            <form onSubmit={e => handleSubmit(e)}>
                <div className="container">
                    <div className="row">
                        <div className="mb-3 col-md-6">
                            <label htmlFor="first_name">Owner First Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-user"></i></span>
                                <input type="text" name="first_name" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.first_name} />
                            </div>
                        </div>

                        <div className="mb-3 col-md-6">
                            <label htmlFor="last_name">Owner Last Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-user"></i></span>
                                <input type="text" name="last_name" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.last_name} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_dba">Doing Business as Name (DBA)</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-tag"></i></span>
                                <input type="text" name="business_dba" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.business_dba} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_legal_name">Legal Business Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-tag"></i></span>
                                <input type="text" name="business_legal_name" onChange={e => handleChange(e)}
                                    className="form-control"
                                    value={fields.business_legal_name} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_ownership">Company Ownership</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-city"></i></span>
                                <select className="custom-select" defaultValue={fields.business_ownership} name="business_ownership"
                                    onChange={e => handleChange(e)}>
                                    <option value="" disabled>Please select...</option>
                                    <option value="Sole Proprietorship">Sole Proprietorship</option>
                                    <option value="Corporation">Corporation</option>
                                    <option value="LLC">LLC</option>
                                    <option value="Partnership">Partnership</option>
                                    <option value="Non-Profit">Non-Profit</option>
                                    <option value="Government">Government</option>
                                    <option value="Tax Exempt">Tax Exempt</option>
                                </select>
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_address">Business Address</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <Autocomplete
                                    apiKey={gmaps}
                                    value={fields.business_address}
                                    className="form-control"
                                    name="business_address"
                                    onChange={e => handleChange(e)}
                                    options={{
                                        fields: ['address_components', 'formatted_address'], types: ['geocode'], componentRestrictions: { country: "us" },
                                    }}
                                    onPlaceSelected={(place, e) => handlePrepopulate(place, e)}
                                />
                            </div>
                            <p className="text-muted mb-0 text-right"><small onClick={() => handleShowSuite()} style={{ cursor: "pointer", userSelect: 'none' }}>
                                {fields.has_suite ? '- Remove Suite #' : '+ Add Suite #'
                                }</small>
                            </p>
                            <div className={"form-group" + (fields.has_suite ? '' : ' d-none')}>
                                <label htmlFor="business_suite">Suite #</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                    <input type="text" name="business_suite" onChange={e => handleChange(e)}
                                        className="form-control" value={fields.business_suite} />
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 col-md-4 d-none" id="cityCol">
                            <label htmlFor="business_city">Business city</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <input type="text" name="business_city" onChange={e => handleChange(e)}
                                    className="form-control"
                                    value={fields.business_city} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-4 d-none" id="stateCol">
                            <label htmlFor="business_state">Business State</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <select className="custom-select" name="business_state"
                                    onChange={e => handleChange(e)} defaultValue={fields.business_state}>
                                    <option value="" disabled>Select state...</option>
                                    {Object.entries(states).map((i, val) =>
                                        <option key={val} value={i[0]}>{i[1]}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="mb-3 col-md-4 d-none" id="zipCol">
                            <label htmlFor="business_zip">Business Zip</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <input type="tel" inputMode="numeric" name="business_zip" data-inputmask="'mask': '99999'" onChange={e => handleChange(e)}
                                    className="form-control"
                                    value={fields.business_zip} />
                            </div>
                        </div>

                        <div className="mb-3 col-md-4">
                            <label htmlFor="business_phone">Business Phone</label>
                            <PhoneField handleChange={handleChange} phone={{ name: 'business_phone', value: fields.business_phone }} extension={{ value: fields.business_phone_extension, name: 'business_phone_extension' }} />

                            {/* <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-phone-alt"></i></span>
                                <input type="tel" inputMode="numeric" name="business_phone" onChange={e => handleChange(e)}
                                    className="form-control" data-inputmask="'mask': '(999) 999-9999'"
                                    value={fields.business_phone} />
                            </div> */}
                        </div>
                        <div className="mb-3 col-md-4">
                            <label htmlFor="business_email">Business Email</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-envelope-open"></i></span>
                                <input type="text" name="business_email" placeholder="example@email.com" onChange={e => handleChange(e)}
                                    className="form-control"  value={fields.business_email} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-4">
                            <label htmlFor="website">Website (optional)</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-globe"></i></span>
                                <input type="text" name="website" placeholder="https://your-business.com" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.website} />
                            </div>
                        </div>



                    </div>
                    <SubmitForm />
                </div>


            </form>
        </>
    )
}

export default Step5
